module.exports = __webpack_public_path__ + "img/20.24bad948.png";